@import '../../theme/global.scss';


:host {
  --badge-height: 1rem;
  --badge-width: var(--badge-height);
  align-items: center;
  background-color: var(--indicator-background-color);
  border-radius: 9999px;
  box-shadow: var(--indicator-box-shadow);
  color: var(--indicator-text-color);

  display: flex;
  font-size: 0.625rem;
  font-weight: 600;
  height: var(--badge-height);
  justify-content: center;
  line-height: 14px;
  width: min-content;
  @include box-sizing;
  @include set-font;
}

:host(.more-than-one) {
  --badge-width: auto;

  .snap-indicator {
    --badge-width: auto;
  }
}

:host(.snap-indicator-tiny.more-than-one) {
  .snap-indicator {
    padding: 0 0.27rem;
  }
}

:host(.snap-indicator-sm) {
  font-size: 12px;
  font-weight: 500;
  height: 1.25rem;
  line-height: 16px;

  .snap-indicator {
    padding: 0 0.125rem;
  }
}

:host(.snap-indicator-sm.more-than-one) {
  .snap-indicator {
    padding: 0 0.27rem;
  }
}

:host(.snap-indicator-lg) {
  font-size: 14px;
  font-weight: 500;
  height: 1.5rem;
  line-height: 20px;

  .snap-indicator {
    padding: 0 0.25rem;
  }
}

:host(.snap-indicator-lg.more-than-one) {
  .snap-indicator {
    padding: 0.125rem 0.375rem;
  }
}

.snap-indicator {
  --badge-width: var(--badge-height);
  align-items: center;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  text-align: center;
  width: var(--badge-width);
}
